// import React, { useEffect, useState } from "react";

// const ScormPlayer = () => {

//   return (
//     <iframe
//       src="https://d3je0klf06zfo3.cloudfront.net/scorm/5_672d3511-779d-4f9a-a1e0-dc2ef49ccf89/story.html?Policy=eyJTdGF0ZW1lbnQiOlt7IlJlc291cmNlIjoiaHR0cHM6Ly9kM2plMGtsZjA2emZvMy5jbG91ZGZyb250Lm5ldC9zY29ybS81XzY3MmQzNTExLTc3OWQtNGY5YS1hMWUwLWRjMmVmNDljY2Y4OS9pbmRleF9sbXMuaHRtbCIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTc1NzE1ODU4MH19fV19&Signature=MOc~jhdthJjfMRpc1ZYNsgboGWjw8sn1v5~Tas7X3WavMWPHcztNo3MMu5CD-h9qVWJiTI7FLGSfvJdijhSaWlf8XghtQKqK2HSZlGjUTq1D~nUnIcQ1XfzHrFfJRsM1IAFAoAD2XUNN65XR5nEMSJkMhLObtYb0xnvtC9LFlSsDbn5OflNxErO6hamGMUEOZJGiVwwUl5rdhY3~kJdPpTlhmXGKdGRzVdk6Ko02Q6--fQmmwMHpOcjyfKsnNcx6Li-xdCPcCbueq1qw2zBeSDDy5-keCkfuxi6YPUhPNgVvtgJxnvlCE87voHT5G~djsjBhE2B4h7-QaCd6-zYk4w__&Key-Pair-Id=E2CVJQSFQKSCDO"
//       width="100%"
//       height="600px"
//       allowFullScreen
//       sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
//       title="SCORM Player"
//     />

//   );
// };

// export default ScormPlayer;


import React from "react";
import { Button, Card } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const ScormPlayer = (props) => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        Width: "100%",
        margin: "10px auto",
        padding: "5px",
      }}
    >
      {/* Back Button */}
      <Button
        type="default"
        icon={<ArrowLeftOutlined />}
        onClick={() => navigate(-1)}
        style={{ marginBottom: "10px", borderRadius: "8px" }}
      >
        
        Go Back
      </Button>

      {/* SCORM Player Card */}
      <Card
        style={{
          borderRadius: "12px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
          overflow: "hidden",
        }}
      >
        <iframe
          src={props?.launchFile}
          width="100%"
          height="600px"
          allowFullScreen
          sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
          title="SCORM Player"
          style={{ border: "none", borderRadius: "12px" }}
        />

        <Card.Meta  title={<span style={{fontSize:"20px",color: "#1ac1cb"}}>{props.course_title}</span>} />
        
      </Card>
    </div>
  );
};

export default ScormPlayer;




